var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPagerdutyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#06ac38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.57 372.751h73.287v133.25H83.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.585 30.429C320.245 9.489 292.961 6 228.557 6H83.57v303.3h144.353c57.424 0 100.253-3.49 138.007-28.554 41.244-27.284 62.5-72.652 62.5-125 0-56.79-26.332-102.157-68.845-125.317zM244.737 245.848h-87.88V71.038l82.804-.634c75.508-.952 113.262 25.698 113.262 85.977 0 64.72-46.637 89.467-108.186 89.467z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagerdutyIcon);
export default __webpack_public_path__ + "static/media/pagerduty-icon.af98efafdd52e70bfaaff0115bf1b544.svg";
export { ForwardRef as ReactComponent };